"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Search = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _qaSelector = _interopRequireDefault(require("@influitive/qa-selector"));

var _inflIcons = require("infl-icons");

var _input = _interopRequireDefault(require("../input"));

var _button = _interopRequireDefault(require("../../button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Search = function Search(props) {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_input.default, _extends({
    "data-qa": (0, _qaSelector.default)('search-input', props),
    "aria-label": "Search",
    prefix: (0, _core.jsx)(_button.default, {
      variant: "search",
      type: "submit",
      "aria-label": "Search"
    }, (0, _core.jsx)(_inflIcons.Icon, {
      icon: "search"
    }))
  }, props)));
};

exports.Search = Search;

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  type: 'search',
  autoCorrect: false,
  autoComplete: false,
  autoCapitalize: false,
  labelHidden: true
}), (0, _recompose.setPropTypes)(_objectSpread({}, _input.default.propTypes)), (0, _recompose.setDisplayName)('Search'))(Search);

exports.default = _default;